module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogcmdiYSgyMTcsIDU3LCAzMSwgMC40KTsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV82IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA2IiBjbGFzcz0iY2xzLTEiIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgcng9IjExIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wl-red-off.svg
// module id = tyPL
// module chunks = 1